var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white-card border border",class:{ force_dark: _vm.isForceDark, 'theme--dark': _vm.isForceDark, 'px-md-4 py-3 px-3': _vm.hasPadding, 'text-center': _vm.isCentered }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }